import { Calendar } from "components/customIcons";
import DateTimePicker from "components/datetimePicker";
import Input from "components/input";
import { Label } from "components/label";
import { IAttractionBuildEventPageForm } from "interfaces";
import { get } from "lodash";
import moment from "moment";
import { Controller, useFormContext } from "react-hook-form";

export const TicketOnSale = ({ isEdit, id }: { isEdit: boolean, id: string | null }) => {
  const {
    register,
    getFieldState,
    getValues,
    control,
    formState: { errors },
  } = useFormContext<IAttractionBuildEventPageForm>(); // retrieve all hook methods

  return (
    <div className="box-container">
      {!isEdit ? (
        (!getFieldState("ticket_on_sale").isTouched ||
        errors["ticket_on_sale"]) && !id ? (
          <p>
            Use this section to provide the start and end dates for when tickets
            will be offered for sale to the public, as well as the total
            quantity of tickets available for your event.
          </p>
        ) : (
          <div className="w-full flex flex-row items-start gap-x-2">
            <div className="w-40 shrink-0 flex flex-row items-center gap-x-2">
              <Calendar />
              Registration date:
            </div>
            <p>
              {moment(
                getValues("ticket_on_sale").open_registration_date
              ).format("HH:mm DD/MM/YYYY")}{" "}
              -{" "}
              {moment(
                getValues("ticket_on_sale").close_registration_date
              ).format("HH:mm DD/MM/YYYY")}
            </p>
          </div>
        )
      ) : (
        <div className="grid gap-x-4 gap-y-6 sm:grid-cols-6 lg:gap-x-6">
          <div className="sm:col-span-3">
            <Label
              required
              id="ticket_on_sale.open_registration_date"
              name="Open Registration date"
            />
            <Controller
              control={control}
              name="ticket_on_sale.open_registration_date"
              render={({ field: { onChange, value = "" } }) => {
                return (
                  <DateTimePicker
                    id="ticket_on_sale.open_registration_date"
                    placeholder="Open Registration date"
                    className="bg-white"
                    error={get(
                      errors,
                      `ticket_on_sale.open_registration_date.message`,
                      ""
                    )}
                    value={value}
                    onChange={(date: any) => date === null ? onChange("") : onChange(moment(date).format("YYYY-MM-DD HH:mm:ss"))}
                  />
                );
              }}
            />
            {get(errors, `ticket_on_sale.open_registration_date`, "") ? (
              <p className="error-text">
                <span className="font-medium">
                  {get(
                    errors,
                    `ticket_on_sale.open_registration_date.message`,
                    ""
                  )}
                </span>
              </p>
            ) : null}
          </div>
          <div className="sm:col-span-3">
            <Label
              required
              id="ticket_on_sale.close_registration_date"
              name="Close Registration date"
            />
            <Controller
              control={control}
              name="ticket_on_sale.close_registration_date"
              render={({ field: { onChange, value = "" } }) => {
                return (
                  <DateTimePicker
                    id="ticket_on_sale.close_registration_date"
                    placeholder="Close Registration date"
                    className="bg-white"
                    error={get(
                      errors,
                      `ticket_on_sale.close_registration_date.message`,
                      ""
                    )}
                    value={value}
                    onChange={(date: any) => date === null ? onChange("") : onChange(moment(date).format("YYYY-MM-DD HH:mm:ss"))}
                  />
                );
              }}
            />
            {get(errors, `ticket_on_sale.close_registration_date`, "") ? (
              <p className="error-text">
                <span className="font-medium">
                  {get(
                    errors,
                    `ticket_on_sale.close_registration_date.message`,
                    ""
                  )}
                </span>
              </p>
            ) : null}
          </div>
        </div>
      )}
    </div>
  );
};
